<template>
  <div id="budgetPerformance" class="common_contentBox">
    <div class="common_search">
      <el-row>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">费用归属部门：</div>
          <div class="content">
            <el-select
              v-model="form.expenseDeptNameOrCode"
              filterable
              remote
              clearable
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="getCostDeptList"
              :loading="applyLoading"
            >
              <el-option v-for="item in costDeptList" :key="item.userId" :label="item.deptName" :value="item.deptCode" />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">费用类型：</div>
          <div class="content">
            <el-select v-model="form.expenseTypeCode" placeholder="请选择" clearable>
              <el-option v-for="item in expenseTypeList" :key="item.id" :label="item.expenseTypeName"
                         :value="item.expenseTypeCode"
              />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">账期（年份）：</div>
          <div class="content">
            <el-select v-model="form.year" placeholder="请选择">
              <el-option v-for="(item,index) in yearList" :key="index" :label="item" :value="item" />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" />
        <div class="btnBar">
          <el-button plain @click="onreset">重置</el-button>
          <el-button type="primary" @click="searchBtn">搜索</el-button>
        </div>
      </el-row>
    </div>
    <div class="common_btnBar">
      <el-button type="primary" @click="exportHandle">导出</el-button>
    </div>
    <commonTable ref="budgetPerformanceTable" />
  </div>
</template>
<script>
import commonTable from '@/components/commonTable';
import { TableRow, TableColumns } from '@/utils/tableOptions.js';
import { budgetPerformanceApi } from './service';

export default {
  name: 'BudgetPerformance',
  data () {
    return {
      applyLoading: false,
      form: {
        year: 2020
      },
      tableData: [],
      expenseTypeList: [],
      costDeptList: [],
      yearList: [],
      rowData: {}
    };
  },
  components: {
    commonTable
  },
  computed: {},
  methods: {
    exportHandle () {
      if (!this.form.expenseDeptNameOrCode) {
        this.$message.error('请选择费用归属部门');
        return;
      } else if (!this.form.year) {
        this.$message.error('请选择账期');
        return;
      }
      let exportData = this.tableData.map(item => {
        return {
          expenseTypeName: item.expenseTypeName,
          deptCode: item.deptCode,
          deptName: item.deptName,
          budget: item.budget,
          currentUse: item.currentUse,
          currentHappen: item.currentHappen
        };
      });
      let str = '<tr>' +
        '<td>费用类型</td>' +
        '<td>费用归属部门编号</td>' +
        '<td>费用归属部门</td>' +
        '<td>年度预算</td>' +
        '<td>当前发生额</td>' +
        '<td>当前发生比率</td>' +
        '</tr>';
      // 增加\t为了不让表格显示科学计数法或者其他格式
      for (let i = 0; i < exportData.length; i++) {
        str += '<tr>';
        for (const key in exportData[i]) {
          str += `<td>${ exportData[i][key] + '\t'}</td>`;
        }
        str += '</tr>';
      }
      const worksheet = 'Sheet1';
      const uri = 'data:application/vnd.ms-excel;base64,';
      let template = `<html xmlns:o="urn:schemas-microsoft-com:office:office"
        xmlns:x="urn:schemas-microsoft-com:office:excel"
        xmlns="http://www.w3.org/TR/REC-html40">
        <head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>
        <x:Name>${worksheet}</x:Name>
        <x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet>
        </x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]-->
        </head><body><table>${str}</table></body></html>`;
      let link = document.createElement('a');
      link.download = '预算执行情况.xls';
      link.style.display = 'none';
      link.href = uri + window.btoa(unescape(encodeURIComponent(template)));
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    onreset () {
      this.form = {
        year: new Date().getFullYear()
      };
    },
    searchBtn () {
      // 校验是否指定了部门和年份
      if (!this.form.expenseDeptNameOrCode) {
        this.$message.error('请选择费用归属部门');
        return;
      } else if (!this.form.year) {
        this.$message.error('请选择账期');
        return;
      }
      budgetPerformanceApi.getBudgetImplementation(this.form).then(res => {
        if (res.status === '200') {
          this.tableData = res.data.map(item => {
            let currentUse = Number(item.budget - item.realBudget).toFixed(2);
            return {
              ...item,
              currentUse,
              budget: Number(item.budget).toFixed(2),
              currentHappen: Number(currentUse) && Number(item.budget) ? Number((currentUse / item.budget) * 100).toFixed(2) + '%' : 0.00 + '%'
            };
          });
          this.setTable();
        }
      });
    },
    getYearList () {
      let myDate = new Date();
      let thisYear = this.form.year = myDate.getFullYear(); // 获取当年年份
      let Section = thisYear - 2021; // 声明一个变量 获得当前年份至想获取年份差
      let arrYear = []; // 声明一个空数组 把遍历出的年份添加到数组里
      for (let i = 0; i <= Section; i++) {
        arrYear.push(thisYear--);
      }
      // 遍历并添加年份到数组
      // arrYear里便是到当前的所有年份了
      this.yearList = arrYear;
      // 进入首页获取完年份后，自动调用当前年份的数据信息
      // this.searchBtn();
    },
    // 获取费用归属部门
    getCostDeptList () {
      budgetPerformanceApi.getBudgetExpenseDeptList().then(res => {
        if (res.status === '200') {
          this.costDeptList = res.data;
        }
      });
    },
    getExpenseTypeList () {
      budgetPerformanceApi.getExpenseTypeList().then(res => {
        if (res.status === '200') {
          this.expenseTypeList = res.data;
        }
      });
    },
    handleDialogClose () {

    },
    budgetBtn (row) {
      this.rowData = row;
      this.$router.push({
        path: '/budgetUsageDetails',
        query: {
          metaActive: '/budgetPerformance',
          expenseDeptNameOrCode: row.deptCode,
          expenseTypeCode: row.expenseTypeCode,
          year: row.year
        }
      });
    },
    setTable () {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title('序号')
          ._width('60')
          ._others('seq')
      );
      tableRow.push(
        new TableColumns()
          ._title('账期（年份）')
          ._width('120')
          ._data('year')
      );
      tableRow.push(
        new TableColumns()
          ._title('费用归属部门')
          ._width('150')
          ._data('deptName')
          ._offOverFlow(true)
          ._field('costDep')
      );
      tableRow.push(
        new TableColumns()
          ._title('费用归属部门编号')
          ._width('150')
          ._data('deptCode')
          ._field('costNo')
      );
      tableRow.push(
        new TableColumns()
          ._title('费用类型')
          ._width('150')
          ._data('expenseTypeName')
          ._field('costType')
      );
      tableRow.push(
        new TableColumns()
          ._title('年度预算')
          ._align('right')
          ._width('150')
          ._data('budget')
      );
      tableRow.push(
        new TableColumns()
          ._title('预算占用金额')
          ._align('right')
          ._width('150')
          ._data('currentUse')
      );
      tableRow.push(
        new TableColumns()
          ._title('预算余额')
          ._align('right')
          ._width('150')
          ._data('realBudget')
      );
      tableRow.push(
        new TableColumns()
          ._title('当前发生比率')
          ._width('120')
          ._align('right')
          ._fixed('right')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <el-button class={ this.rowData.id === row.id ? 'activeCell' : '' } type="text" onClick={() => {
                    this.budgetBtn(row);
                  }}> {row.currentHappen}</el-button>
                </div>
              );
            }
          })
      );
      let column = tableRow._cols();
      this.$refs.budgetPerformanceTable.setColumn(column, {
        page: false,
        maxHeight: '650px'
      });
      this.$refs.budgetPerformanceTable.loadStaticTable(this.tableData);
    }
  },
  activated () {
    // 用于进入页面的刷新（有条件时，无时不调用）
    if (this.form.expenseDeptNameOrCode && this.form.year) {
      this.searchBtn();
    }
  },
  mounted () {
    this.getCostDeptList();
    this.getYearList();
    this.getExpenseTypeList();
    this.setTable();
  }
};
</script>
<style lang="scss" scoped>
#budgetPerformance {
  width: 100%;
  .activeCell{
    color:#9900ff;
    text-decoration: underline;
  }
}
</style>
